import {
  ICreditScoreConfigResponse,
  IUpdateCreditScoreConfigRequest,
  IUpdateCreditScoreConfigResponse,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';
import { CacheTags } from '../../types/cacheTags';

export const creditScoreConfigApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchCreditScoreConfig: builder.query<ICreditScoreConfigResponse, string>({
      query: organisationId => ({
        url: `credit-score-config`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [CacheTags.CreditScoreConfig],
    }),
    updateCreditScoreConfig: builder.mutation<IUpdateCreditScoreConfigResponse, { organisationId: string; config: IUpdateCreditScoreConfigRequest }>({
      query: ({ organisationId, config }) => ({
        url: `credit-score-config`,
        method: `PUT`,
        data: config,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      // Scores are computed at read time, so cached contact pages go stale as soon as the config changes
      invalidatesTags: [CacheTags.CreditScoreConfig, CacheTags.SingleContact],
    }),
    resetCreditScoreConfig: builder.mutation<IUpdateCreditScoreConfigResponse, string>({
      query: organisationId => ({
        url: `credit-score-config`,
        method: `DELETE`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      // Scores are computed at read time, so cached contact pages go stale as soon as the config changes
      invalidatesTags: [CacheTags.CreditScoreConfig, CacheTags.SingleContact],
    }),
  }),
});

export const {
  useFetchCreditScoreConfigQuery,
  useUpdateCreditScoreConfigMutation,
  useResetCreditScoreConfigMutation,
} = creditScoreConfigApi;
